import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { node, object } from 'prop-types';
import classnames from 'classnames';

import ActionIcon from 'elements/ActionIcons/ActionIcon';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';

import styles from './MapSection.css';

class MapSection extends Component {
  constructor() {
    super();

    this.el = document.createElement('div');
    this.el.classList.add(styles.map);
  }

  static propTypes = {
    children: node.isRequired,
    link: object.isRequired,
    secondaryBtn: object.isRequired,
    primaryBtn: object.isRequired
  };

  wrapper = null;

  componentDidMount = () => {
    this.wrapper = document.getElementById('hero-wrapper');

    if (this.wrapper) {
      this.wrapper.prepend(this.el);
    }
  }

  componentWillUnmount = () => {
      this.wrapper.prepend(this.el);
  }

  render () {
    const { children, link, secondaryBtn, primaryBtn } = this.props;

    return (
      <Fragment>
        {
          ReactDOM.createPortal(
            children,
            this.el
          )
        }
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <ActionIcon
              customClasses={styles.actionLink}
              icon="customer-support"
              type="20"
              onClick={link.onClick}
            />
            <LinkFreeStanding
              className={styles.link}
              icon={{ direction: 'left', name: 'customer-support', type: '20' }}
              onClick={link.onClick}
              size="m"
              dark
            >
              {link.text}
            </LinkFreeStanding>
            <Button
              classes={classnames(styles.button, 'white', 'secondary', 'small')}
              onClick={secondaryBtn.onClick}
            >
              {secondaryBtn.text}
            </Button>
            <Button
              classes={classnames(styles.button, 'white', 'small')}
              onClick={primaryBtn.onClick}
            >
              {primaryBtn.text}
            </Button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MapSection;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/MapSection/MapSection.js